module.exports = __webpack_public_path__ + "static/media/Culvert.a90e827c.png";